module.exports = __webpack_public_path__ + "static/img/ico_bg_1o.f3707fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico_bg_1o.png
// module id = F4hr
// module chunks = 1